/* Displays an expandable video with a small preview.
 * To get a silent looping video that never expands, leave out `vimeoId` and pass only `previewSrc` */
import React from "react";
import PropTypes from "prop-types";

import { InlineVideo } from "@components/Video";

import styles from "../ImageBlock/ImageBlock.module.scss";

export default function VideoBlock({ previewSrc, previewPoster, vimeoId }) {
  return (
    <div className={styles.grid}>
      <div className={styles.container}>
        <InlineVideo src={previewSrc} poster={previewPoster} vimeoId={vimeoId} />
      </div>
    </div>
  );
}

VideoBlock.propTypes = {
  previewSrc: PropTypes.string.isRequired,
  previewPoster: PropTypes.string,
  vimeoId: PropTypes.number,
};
